import { atom } from 'recoil';
import { sessionStorageEffect } from '@app/recoil';

const inboxNewMessageExistState = atom<boolean>({
  key: 'inboxNewMessageExistState',
  default: false,
  effects: [sessionStorageEffect('inbox_new_message_exist_state')],
});

export default inboxNewMessageExistState;
